import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiList = ({ palette }: Pick<Tokens, 'palette'>) =>
  ({
    MuiList: {
      styleOverrides: {
        root: {
          padding: 0,
          backgroundColor: palette.pure.light,
          boxShadow: 'none',
          '& .Mui-disabled': {
            color: palette.text.disabled,
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: 'inherit',
          '& .MuiSvgIcon-root': {
            width: spacing(3),
            height: spacing(3),
          },
        },
      },
    },
  }) satisfies ComponentCreation
